<template>
  <button class="btn" :class="`btn--${props.type}`">
    <ArrowIcon class="btn__arrow" />
  </button>
</template>

<script setup>
  import { Props } from './props';
  //----------------------------
  import ArrowIcon from '../../svg/ArrowIcon.vue';
  //----------------------------
  const props = defineProps(Props());
</script>

<style lang="scss" scoped>
  @import './styles';
</style>